import React from "react";

import { TicketPurchaseConfirmationPropTypes } from "./types";
import { isApprovalPending, isInvoicePaymentPending } from "../../util";

export function useTicketPurchaseConfirmationService(props: TicketPurchaseConfirmationPropTypes) {
  const pendingApproval = React.useMemo(
    () => props.state.participantData && isApprovalPending(props.state.participantData?.ticketStatus),
    [props.state.participantData]
  );

  const invoicePaymentPending = React.useMemo(
    () =>
      Boolean(
        props.state.participantData?.regPurchaseOrder?.forwardedToInvoicePayer &&
          isInvoicePaymentPending(props.state.participantData?.regPurchaseOrder?.invoicePaymentRequest?.status)
      ),
    [props.state.participantData?.regPurchaseOrder]
  );
  const invoicePaymerEmail = React.useMemo(
    () => props.state.participantData?.regPurchaseOrder?.invoicePaymentRequest?.invoicePayerEmail ?? "",
    [props.state.participantData?.regPurchaseOrder?.invoicePaymentRequest?.invoicePayerEmail]
  );

  return {
    invoicePaymentPending,
    invoicePaymerEmail,
    pendingApproval
  };
}
